import BoxContainer from "@standard/components/BoxContainer/BoxContainer";
import { useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import DataForm from "@standard/components/DataForm/DataForm";
import { DatasourceAPI, JobAPI, OrderAPI } from "api";
import {
  AlertService,
  DateService,
  ErrorService,
  FormService,
  NumberService,
} from "@standard/services";
import { useForm } from "react-hook-form";
import { JOB_STATUS, JobStatusComponent } from "data/jobStatus";
import Modal from "@standard/components/Modal";
import AlertBar from "@standard/components/AlertBar";
import JobHistories from "../Job/JobHistories";
import JobDocuments from "../Job/JobDocuments";
import { USER_ROLE } from "data/constants";
import JobInfo from "./JobInfo";
import JobAlertReject from "../Job/JobAlertReject";

export default ({ history, url }) => {
  const { id, action } = useParams();
  const [errors, setErrors] = useState([]);
  const [disabled, setDisabled] = useState(action === "view");
  const [isLoading, setIsLoading] = useState(true);
  const [jobHistories, setJobHistories] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [jobInfo, setJobInfo] = useState({
    status: JOB_STATUS.PROCESSING,
    jobAuthenHistories: [],
  });
  const defaultValues = { id: id };
  const jobDocumentRef = useRef();
  const reactHookForm = useForm({ defaultValues });

  useEffect(() => {
    if (id !== undefined) retrieveData(id);
  }, []);

  const retrieveData = (id) => {
    FormService.getRequest(url, id).then((result) => {
      setJobHistories(result.jobHistories);
      setDocuments(result.documents);
      setJobInfo(result);
      setIsLoading(false);
      setDisabled(
        ![JOB_STATUS.PROCESSING, JOB_STATUS.REJECT].includes(result.status)
      );
      setErrors([]);
    });
  };

  const saveData = (newData) => {
    setIsLoading(true);

    const params = { ...newData, id: id };

    params.documents = documents.map((item, index) => {
      params[`assets[${item.key}]`] = item.values.assets;

      return {
        _id: item.key,
        deletedAssets:
          item.values.assetsPreview
            ?.filter((asset) => asset.isDelete === true)
            .map((asset) => asset.assetId) ?? [],
      };
    });

    FormService.submitRequestWithFile(url, params)
      .then((res) => {
        if (res.data.status === JOB_STATUS.AUTHENING) {
          AlertService.done("Your job is authening.").then(() =>
            history.push(`/${url}`)
          );
        } else {
          // jobDocumentRef.current.resetForm();
          retrieveData(id);
        }
      })
      .catch((err) => {
        console.log("Catch error", err);
        setIsLoading(false);
        setErrors(err);
      });
  };

  const onSubmit = (newData) => {
    AlertService.confirm("Do you want to save data").then((res) => {
      if (res === true) saveData(newData);
    });
  };

  const tabs = [
    {
      name: "document",
      label: "Documents",
      fields: [
        {
          type: "custom",
          control: (
            <JobDocuments
              disabled={disabled}
              isLoading={isLoading}
              ref={jobDocumentRef}
              key="jobDocuments"
              values={documents}
              onChange={(newDocuments) => {
                setDocuments(newDocuments);
              }}
              onFileChange={(index, field) => {
                setDocuments((prev) => {
                  return prev.map((item, itemIndex) => {
                    if (itemIndex === index) item.values.assets = field.value;

                    return item;
                  });
                });
              }}
            />
          ),
        },
      ],
    },
    {
      name: "history",
      label: "History",
      fields: [
        {
          type: "custom",
          control: <JobHistories key="jobHistories" values={jobHistories} />,
        },
      ],
    },
    {
      name: "authenhistory",
      label: "Authen History",
      fields: [
        {
          type: "custom",
          control: (
            <JobHistories
              key="jobAuthenHistories"
              values={jobInfo.jobAuthenHistories}
            />
          ),
        },
      ],
    },
  ];

  const fieldErrors = ErrorService.convertToArray(
    reactHookForm.formState.errors
  );

  const requestAuthen = () => {
    AlertService.confirm("Do you want to request authen ?").then((res) => {
      if (res === true) {
        JobAPI.requestAuthen(id).then(() =>
          AlertService.done("Submit request !").then(() =>
            history.push(`/${url}`)
          )
        );
      }
    });
  };

  let buttons = [];
  const status = jobInfo.status;

  const leftPanel = (
    <div>
      <JobStatusComponent value={status} />
    </div>
  );

  if (status === JOB_STATUS.REJECT || status === JOB_STATUS.PROCESSING) {
    buttons = [
      <input
        type="button"
        key="requestauthen"
        className="btn btn-info mr-2"
        value="Request Authen"
        onClick={requestAuthen}
      />,
    ];
  }

  return (
    <BoxContainer loading={isLoading} errors={errors.concat(fieldErrors)}>
      <>
        {status === JOB_STATUS.REJECT && (
          <JobAlertReject value={jobInfo.rejectInfo} />
        )}
        <JobInfo value={jobInfo} />
        <DataForm
          leftPanel={leftPanel}
          refForm={reactHookForm}
          tabs={tabs}
          buttons={buttons}
          url={url}
          enableSave={!disabled}
          enableTabs={true}
          onSubmit={onSubmit}
        ></DataForm>
      </>
    </BoxContainer>
  );
};
